umpApp.introBuild = {
    init: function () {

        // affiche loader
        $(".loader").css({ "display": "block" });
        // affiche text 1
        $("#intro-text").css({ "display": "block" });
        $(".scene.text-one").css({ "display": "block" });

        this.preloadSeqInfoText();

        //skip intro
        // timeCheckBuild3D = setTimeout(function () {
        //     umpApp.introBuild.init3D();
        // }, 1000);


    },
    init3D: function () {
        console.log("init 3D");

        ump3Dintro.initSceneOne();
        ump3Dintro.initSceneTwo();
        ump3Dintro.initSceneThree();

        this.checkReadyAndStart();

        //skip intro
        //umpApp.intro.start();
    },
    checkReadyAndStart: function () {
        if (initAll3D) {
            clearTimeout(timeCheckBuild3D);
            umpApp.intro.start();
        } else {
            timeCheckBuild3D = setTimeout(function () {
                umpApp.introBuild.checkReadyAndStart();
            }, 300);
        }
    },
    preloadSeqInfoText: function () {
        var preload;
        var blob_url;
        var manifest = [];
        var index = 0;

        reload();

        function reload() {
            if (preload != null) {
                preload.close();
            }
            for (var index = 0; index < 50; index++) {
                manifest.push("PAGE%20ATTENTE_00" + (100 + index) + ".png");
            }

            preload = new createjs.LoadQueue(true, "../img/intro/sequence/");
            preload.on("fileload", handleFileLoad);
            preload.setMaxConnections(5);
            while (manifest.length > 0) {
                loadAnother();
            }
        }

        function loadAnother() {
            var item = manifest.shift();
            preload.loadFile(item);
        }

        function handleFileLoad(event) {
            console.log('event: ', event);
            var result = preload.getResult(event.item.id, true);
            blob_url = URL.createObjectURL(result);
            seqScr.push({ src: blob_url });
            index++;
            if (index == 50) {
                console.log("end preload", seqScr);
                umpApp.introBuild.init3D();
            }
        }
    }
};